// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.password-form-header[data-v-0f415027] {\n    color: #667d88 !important;\n    font-weight: lighter !important;\n}\n", ""]);
// Exports
module.exports = exports;
